import React, { useTransition } from 'react';
import styles from './styles.module.css';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
interface PlayAgainButtonProps {
    onClick: () => void;
    disabled?: boolean;
}
export const PlayAgainButton: React.FC<PlayAgainButtonProps> = ({  onClick, disabled}) => {
  const {t} = useTranslation();
  return (
    <button 
      className={clsx(styles.playAgainButton,"fontSizeSm fontWeightBold")}
      onClick={onClick}
      tabIndex={0}
      disabled={disabled}
    >
      {t("playAgain")}
    </button>
  );
};